var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-4"},[_c('EmailAddressesProperty',{attrs:{"contact-id":_vm.contactId}}),_c('PhoneNumbersProperty',{attrs:{"contact-id":_vm.contactId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }